import * as EvaluationsModels from 'models/evaluations';
import * as StudentsModels from 'models/students';
import * as TeachersModels from 'models/teachers';
import * as R from 'ramda';
export const getGenderNames = (lang, genderId) => {
    const genderEnum = lang === 'ja' ? TeachersModels.GenderEnum : StudentsModels.GenderEnum;
    return genderEnum[genderId];
};
export const getTagNames = (tags, lang) => {
    const key = lang ? (lang === 'ja' ? 'tag_name_ja' : 'tag_name_en') : 'name';
    return R.map((tag) => R.prop(key, tag) || R.prop('name', tag), tags);
};
export const getTagNamesFromPickUpDetailTag = (tags, lang) => {
    return tags.map((tag) => (lang === 'ja' ? tag.tag_name_ja : tag.tag_name_en));
};
export const normalizeMyTagData = (lang) => (data) => {
    return Object.assign(Object.assign({}, data), { tags: data.tags.map((tag) => ({
            id: tag.id.toString(),
            category_id: tag.category_id.toString(),
            name: lang === 'ja' ? tag.tag_name_ja : tag.tag_name_en,
        })) });
};
export const transformTagNameToTagIds = (tagNames, tags) => {
    return R.map((tagName) => tags.filter((tag) => tag.name === tagName)[0].id, tagNames);
};
export const transformCategoryToTags = (lang) => (categories) => {
    return R.map((category) => lang === 'ja'
        ? {
            id: category.tag_id,
            name: category.tag_name_ja,
            category_id: category.id,
            category_name: category.category_name_ja,
        }
        : {
            id: category.tag_id,
            name: category.tag_name_en,
            category_id: category.id,
            category_name: category.category_name_en,
        }, categories);
};
export const getPurposeIds = (purposes) => {
    return R.map((purpose) => Number(R.prop('id', purpose)), purposes);
};
export const getPurposeNames = (purposes) => {
    return R.map((purpose) => R.prop('name', purpose), purposes);
};
export const transformToPurposeIds = (lang) => (purposes) => {
    return R.map((purpose) => lang === 'ja'
        ? TeachersModels.PurposeEnum[purpose]
        : StudentsModels.PurposeEnum[purpose], purposes);
};
export const getChatQualityNames = (lang) => (chatQualityValues) => {
    const chatQualityChoices = lang === 'ja'
        ? EvaluationsModels.chatQualityTeacherEnum
        : EvaluationsModels.chatQualityStudentEnum;
    return chatQualityValues.map((value) => chatQualityChoices[value]);
};
